import { useState } from 'react';
import { IconPlay } from './icons';

/**
 * Click-to-load YouTube embed (youtube-nocookie.com): nothing is loaded from YouTube until the
 * visitor presses play, which keeps the page fast and avoids tracking cookies.
 */
export function YouTube({ id, title }: { id: string; title?: string }) {
  const [active, setActive] = useState(false);
  // The sharp 16:9 still (1280x720) exists for HD uploads. Otherwise YouTube answers with a
  // 120x90 placeholder, and the 4:3 hqdefault (cropped to fit) is the best there is.
  const [still, setStill] = useState<'maxresdefault' | 'hqdefault'>('maxresdefault');
  if (active) {
    return (
      <div className="yt">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1`}
          title={title ?? 'Product video'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    );
  }
  return (
    <button type="button" className="yt" onClick={() => setActive(true)} aria-label={`Play video${title ? `: ${title}` : ''}`} style={{ padding: 0, width: '100%' }}>
      <img
        src={`https://i.ytimg.com/vi/${encodeURIComponent(id)}/${still}.jpg`}
        alt=""
        loading="lazy"
        onLoad={(e) => still === 'maxresdefault' && e.currentTarget.naturalWidth <= 120 && setStill('hqdefault')}
        onError={() => setStill('hqdefault')}
      />
      <span className="play-btn">
        <IconPlay size={26} />
      </span>
    </button>
  );
}
